import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, FloatingLabel, Spinner } from 'react-bootstrap';
import Styles from '../../styles/authentication/createNewPass.module.css';
// import { useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { CreatePassHelper } from '../../helpers/auth/create-new-password';
import { Helmet } from 'react-helmet';

const CreateNewPassword: React.FC = () => {
  const {
    formErrors,
    values,
    handleCreatePassword,
    handleChange,
    isProcessing,
  } = CreatePassHelper();
  // const navigate = useNavigate();

  // password show and hide
  const [showPassword, setShowPassword] = useState(false);


  // Separate states for each label's active state
  const [emailActive, setEmailActive] = useState(false);
  const [passActive, setPassActive] = useState(false);
  const [confirmPassActive, setConfirmPassActive] = useState(false);

  // handle the show and hide password functionality
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <Helmet>
        <title>Create New Password - Mohit's Shopping App</title>
        <meta
          name="description"
          content="Create a new password for your account to securely access your profile and shopping experience at Mohit's Shopping App."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta property="og:title" content="Create New Password - Mohit's Shopping App" />
        <meta
          property="og:description"
          content="Set a new password to regain access to your account and continue shopping securely on Mohit's Shopping App."
        />
        <meta
          property="og:image"
          content={`${process.env.PUBLIC_URL}/favicon.png`}
        />
        <meta
          property="og:url"
          content="https://mohit-online-shopping.netlify.app/create-new-password"
        />
      </Helmet>

      {/* Main Heading of the Create New Password Page */}
      <h1 className="visually-hidden">Create New Password - Set Your New Account Password</h1>

      {/* Cursor Effect add in future*/}
      {/* <div
        className={`${Styles.cursor} ${cursorGrowing ? Styles.growing : ''}`}
        style={{
          top: `${cursorPosition.y}px`,
          left: `${cursorPosition.x}px`,
        }}
      ></div> */}

      <section className={Styles.changePasswordSec}>
        <Container fluid className={Styles.container}>
          <Row className={`justify-content-left ${Styles.row}`}>
            <Col className={`d-flex align-items-center justify-content-center ${Styles.col}`} md={6}>
              <div className={Styles.formWrapper}>
                <h1>Change Password</h1>
                <Form onSubmit={handleCreatePassword}>
                  <Form.Group>
                    <FloatingLabel
                      controlId="floatingInput"
                      label="Your Email"
                      className={`${Styles.floatingLabel} ${emailActive ? Styles.floatingLabelActive : ''}`}
                    >
                      <Form.Control
                        type="email"
                        placeholder="Email"
                        name="email"
                        className={Styles.input}
                        autoComplete="off"  // Use camelCase for JSX
                        value={values.email}
                        onChange={handleChange}
                        disabled={isProcessing}
                        onFocus={() => setEmailActive(true)}
                        onBlur={(e) => setEmailActive(e.target.value !== '')}
                      />
                    </FloatingLabel>
                  </Form.Group>
                  <Form.Group>
                    <FloatingLabel
                      controlId="floatingInput"
                      label="New Password"
                      className={`${Styles.floatingLabel} ${passActive ? Styles.floatingLabelActive : ''}`}
                    >
                      <Form.Control
                        // type="text"
                        // placeholder="New Password"
                        // name="password"
                        // className={Styles.input}
                        // autoComplete="off"  // Use camelCase for JSX
                        onFocus={() => setPassActive(true)}
                        onBlur={(e) => setPassActive(e.target.value !== '')}
                        // value={values.newPassword}
                        // onChange={handleChange}
                        // disabled={isProcessing} // Disable when processing
                        type={showPassword ? 'text' : 'password'}
                        placeholder="New Password"
                        name="newPassword"
                        className={Styles.input}
                        autoComplete="off"
                        value={values.newPassword}
                        onChange={handleChange}
                        disabled={isProcessing}

                      />
                    </FloatingLabel>
                  </Form.Group>
                  <Form.Group>
                    <FloatingLabel
                      controlId="floatingInput"
                      label="Confirm Password"
                      className={`${Styles.floatingLabel} ${confirmPassActive ? Styles.floatingLabelActive : ''}`}
                    >
                      <Form.Control
                        // type={showPassword ? 'text' : 'password'}
                        // placeholder="Confirm Password"
                        // name="password"
                        // className={Styles.input}
                        // autoComplete="off"  // Use camelCase for JSX
                        onFocus={() => setConfirmPassActive(true)}
                        onBlur={(e) => setConfirmPassActive(e.target.value !== '')}
                        // value={values.confirmPassword}
                        // onChange={handleChange}
                        // disabled={isProcessing} // Disable when processing
                        type={showPassword ? 'text' : 'password'}
                        placeholder="Confirm Password"
                        name="confirmPassword"
                        className={Styles.input}
                        autoComplete="off"
                        value={values.confirmPassword}
                        onChange={handleChange}
                        disabled={isProcessing}
                      />
                      <div
                        onClick={togglePasswordVisibility}
                        className={Styles.authToggleBtn}
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </div>
                    </FloatingLabel>
                  </Form.Group>
                  <Button
                    type="submit"
                    className={Styles.changePasswordBtn}
                    disabled={isProcessing}
                  >
                    {Object.keys(formErrors).length > 0 ? (
                      'Change Password'
                    ) : isProcessing ? (
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className={Styles.customSpinner} // Applying custom spinner styles here
                      />
                    ) : (
                      'Change Password'
                    )}
                  </Button>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default CreateNewPassword;
